import { ReactElement } from 'react'

import { ExportMenu } from '@features/expertReports'

import { useDownloadExpertTrialBalanceExport } from '../../hooks/useDownloadExpertTrialBalanceExport'

export const ExpertTrialBalanceExportMenu = (): ReactElement => {
  const { downloadExport, isExporting } = useDownloadExpertTrialBalanceExport()

  return <ExportMenu isExporting={isExporting} onSelectFormat={downloadExport} />
}
